import { addToChainAfter, ApiHandler } from "@insite/client-framework/HandlerCreator";
import { Session } from "@insite/client-framework/Services/SessionService";
import {
    chain,
    DispatchCompleteSignIn,
    SignInParameter,
    SignInResult,
} from "@insite/client-framework/Store/Context/Handlers/SignIn";

/** SessionStorage key used by PostLoginRelayWidget to run only after a fresh login. */
export const POST_LOGIN_RELAY_FLAG_KEY = "postLoginRelay";

type HandlerType = ApiHandler<
    SignInParameter,
    SignInResult,
    {
        tokenSuccessfullyRequested?: boolean;
        authenticatedSession?: Session;
    }
>;

/**
 * Sets a sessionStorage flag when sign-in succeeds so that PostLoginRelayWidget
 * only triggers the capture + redirect flow on the next page load (i.e. after login).
 */
export const SetPostLoginRelayFlag: HandlerType = props => {
    if (props.authenticatedSession && typeof sessionStorage !== "undefined") {
        sessionStorage.setItem(POST_LOGIN_RELAY_FLAG_KEY, "1");
    }
};

addToChainAfter(chain, DispatchCompleteSignIn, SetPostLoginRelayFlag);
